// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var InfoWindowItemType;
(function (InfoWindowItemType) {
    InfoWindowItemType[InfoWindowItemType["None"] = -1] = "None";
    InfoWindowItemType[InfoWindowItemType["Bars"] = 0] = "Bars";
    InfoWindowItemType[InfoWindowItemType["Date"] = 1] = "Date";
    InfoWindowItemType[InfoWindowItemType["Time"] = 2] = "Time";
    InfoWindowItemType[InfoWindowItemType["Open"] = 3] = "Open";
    InfoWindowItemType[InfoWindowItemType["High"] = 4] = "High";
    InfoWindowItemType[InfoWindowItemType["Low"] = 5] = "Low";
    InfoWindowItemType[InfoWindowItemType["Close"] = 6] = "Close";
    InfoWindowItemType[InfoWindowItemType["HighLow"] = 7] = "HighLow";
    InfoWindowItemType[InfoWindowItemType["Change"] = 8] = "Change";
    InfoWindowItemType[InfoWindowItemType["DailyChange"] = 9] = "DailyChange";
    InfoWindowItemType[InfoWindowItemType["Ticks"] = 10] = "Ticks";
    InfoWindowItemType[InfoWindowItemType["Volume"] = 11] = "Volume";
    InfoWindowItemType[InfoWindowItemType["Ask"] = 12] = "Ask";
    InfoWindowItemType[InfoWindowItemType["Bid"] = 13] = "Bid";
    InfoWindowItemType[InfoWindowItemType["PortfolioGrowth"] = 14] = "PortfolioGrowth";
    InfoWindowItemType[InfoWindowItemType["Funding"] = 15] = "Funding";
    InfoWindowItemType[InfoWindowItemType["Countdown"] = 16] = "Countdown";
    /*, Price, Last, Value */
})(InfoWindowItemType || (InfoWindowItemType = {}));
